export default __webpack_public_path__ + "static/media/Hardware copy.d5ebe93e.jpg";